import * as React from 'react';
import Svg, {SvgProps, Circle} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    {...props}
    fill="none"
    stroke="none"
    strokeWidth={2}>
    <Circle stroke={props.fill || '#888'} cx={12} cy={12} r={1} />
    <Circle stroke={props.fill || '#888'} cx={19} cy={12} r={1} />
    <Circle stroke={props.fill || '#888'} cx={5} cy={12} r={1} />
  </Svg>
);
export default SvgComponent;
